import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-phone-number-input/style.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import 'react-toastify/dist/ReactToastify.css';
import BBApp from './BBApp';
import { getMyProfile } from './store/actions/user.action';
import { RootState } from './store/reducers';
import { history, isUserLoggedIn, loadBasicAPIs, loadRecaptchaScript, Logout, recaptchaLoaded, scrollToTop } from './utils/handler';
import { SessionManger } from './utils/SessionManger';
import { FillOutMandatoryFields, UpgradeAccount } from './views/components/LoginWindow';
// import 'reactjs-popup/dist/index.css';
import { getMyLeads } from 'store/actions/lead.action';
import { SHOW_LOGIN_WINDOW } from 'store/actions/types';
import { BotErrorPage, LoadingPage } from 'views/components/CommonPages';
import EmailVerification from 'views/components/EmailVerification';
import { ErrorPage } from 'views/components/ErrorPage';
import { AppraisalPayment, LowBudgetAlert, PasswordAlert, RemodelAlert } from 'views/components/Popup';
import SellPrivacyPolicy from 'views/sell_privacy_policy';
import SellTermsAndService from 'views/sell_terms_and_service';
import './common.scss';
import './i18n';
import TermsAndService from './views/TermsAndService';

const App: React.FC = (): JSX.Element => {
  const dispatch = useDispatch();
  let { robotPage } = useSelector((state: RootState) => state.mainReducer);
  const { showLoginWindow, googleProfile, showVerificationCodeWindow, passwordAlertBox, showPromoAlert, badLeadAlert, paymentFailedAlert, showRemodelAlert, showUpgradeWindow, showPrivacyPolicy, locationNotSupport, showPaymentPopup, pageLoading, showSellTerms, showSellPrivacy } = useSelector((state: RootState) => state.mainReducer);
  const { lowBudgetWindow } = useSelector((state: RootState) => state.leadReducer);
  // const [isAppraisalRouter, setIsAppraisalRouter] = useState(true);
  const [showScrollTopIcon, setShowScrollTopIcon] = useState(false);
  // useEffect(() => {
  //   // console.log('previousAction, showLoginWindow, showVerificationCodeWindow', previousAction, showLoginWindow, showVerificationCodeWindow)
  //   // console.log('showLoginWindow && !showVerificationCodeWindow && previousAction', showLoginWindow && !showVerificationCodeWindow && previousAction)
  //   // if (!showLoginWindow && !showVerificationCodeWindow && previousAction) {
  //   //   if (previousAction === 'buyDomain') buyNewDomain();
  //   // }
  // }, [previousAction, showVerificationCodeWindow]);

  SessionManger();

  useEffect(() => {
    if (!recaptchaLoaded()) {
      loadRecaptchaScript();
    }
    loadBasicAPIs();
    if (isUserLoggedIn()) {
      getMyLeads();
      let res = getMyProfile();
      if (!res) Logout();
    }
    checkRouter(history.location);
    history.listen((location: typeof history) => {
      checkRouter(location);
    });
    window.addEventListener('scroll', scrollListener);
    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, []);
  useEffect(() => {
    if (showLoginWindow) {
      console.log('showLoginWindow in app component', showLoginWindow);
      history.push('/login');
      dispatch({ type: SHOW_LOGIN_WINDOW, payload: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showLoginWindow]);
  const scrollListener = (e) => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = (winScroll / height) * 100;
    setShowScrollTopIcon(scrolled > 10 ? true : false);
  };

  const checkRouter = (location: typeof history) => {
    scrollToTop();
    // const appraisalRouter = _.find(appraisalRoutes, (route: {path: string; isPrivateRoute: boolean}) => route.path?.toLowerCase() === location.pathname.toLowerCase());
    // setIsAppraisalRouter(appraisalRouter ? true : false);
  };
  return robotPage ? (
    <BotErrorPage />
  ) : locationNotSupport ? (
    <ErrorPage />
  ) : (
    <>
      {!_.isEmpty(lowBudgetWindow) && <LowBudgetAlert />}
      {!_.isEmpty(googleProfile) && <FillOutMandatoryFields />}
      {pageLoading === true && <LoadingPage />}
      {(passwordAlertBox || showPromoAlert || badLeadAlert || paymentFailedAlert) ? <PasswordAlert /> : showVerificationCodeWindow ? <EmailVerification /> : null}
      {showRemodelAlert === true && <RemodelAlert />}
      {showUpgradeWindow === true && <UpgradeAccount />}
      {showPaymentPopup ? <AppraisalPayment /> : null}
      {showPrivacyPolicy === true && <TermsAndService />}
      {showSellTerms && <SellTermsAndService />}
      {showSellPrivacy && <SellPrivacyPolicy />}
      {/* {showLoginWindow === true && <LoginWindow history={history} />} */}
      {showScrollTopIcon ? <i className="scroll-top-icon fa-lg fa-solid fa-circle-chevron-up" onClick={scrollToTop}></i> : null}

      {/* {isAppraisalRouter ? <AppraisalApp /> : } */}
      <BBApp />
      <ToastContainer autoClose={15000} position="top-center" className="toastStyle" />
    </>
  );
};

export default App;
